// 事件源 ID；v1.5.1 新增配置项；用于 SDK 子组件与宿主页面共用统计 App Key 和全局对象实例 window.mtstat 时，区分埋点事件上报的数据；默认值为 '0'，即表示该埋点事件为宿主上报；具体的值需要申请 申请邮件模板
const eventSource = 1029;

/**
 * 上报埋点事件；SDK 上报失败时静默吞掉，避免影响业务页面。
 */
export function mtstatTrack(eventId: string, params: Record<string, any>) {
  try {
    // @ts-ignore
    window.mtstat?.track(eventId, params, () => {}, { eventSource });
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[mtstat] track failed:', eventId, error);
    }
  }
}
